import React from 'react';
import { connect } from 'react-redux';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { editUsuario, fetchUsuarios } from '../../actions/usuariosActions';
import { putSeller, clearLogisticaForSeller, fetchSeller, resetSellers, updateListSellers } from '../../actions/sellersActions';
import { editando, setObject } from '../../actions/generalActios';
import { fetchTiposPublicacionAdmById } from '../../actions/tiposPublicacionActions';
import {
    deleteSellerApi,
    postTiposPublicacionAsociarSeller,
    updateCdnSellerApi,
    postCrearCdnSellerApi,
    postCargarDatosBancariosApi,
    postCargarDatosBancariosManualApi
} from '../../api/axios';
import DatosContactos from './DatosContactos';
import DatosBasicos from './DatosBasicos';
import Publicacion from './Publicacion';
import Moderador from './Moderador';
import MailUsuario from './MailUsuario';
import Liquidacion from './Liquidacion';
import Tab from '../General/Tab';
import ModalItem from '../General/Modal';
import GoBackArrow from '../General/GoBackArrow';
import MiniSpinner from '../General/MiniSpinner';
import BigSpinner from '../General/BigSpinner';
import LogisticaPropia from "./LogisticaPropia";
import { isEmail } from '../../utilities/formatString';
import { toast } from '../../utilities/appToast';
import BannerTienda from './BannerTienda';
import DatosBancarios from './DatosBancarios';
import { formatFile } from '../../utilities/formatFile';
import { withNavigation } from '../General/withNavigation';
import Zipnova from './Zipnova';
import PropTypes from 'prop-types';
import { resolveTipoPublicacionId } from '../../helper/tipoPublicacionHelper';
import { selectSellerMerged } from '../../helper/sellerMergedSelector';
import AuditoriaPrecioStock from '../Publicaciones/Components/ABM/AuditoriaPrecioStock';

const getErroresApi = (error) => {
    const data = error?.response?.data;

    if (Array.isArray(data?.errores)) {
        return data.errores
            .map((e) => {
                if (e == null) return null;
                if (typeof e === 'string') return e;
                if (typeof e === 'object') {
                    const msg = e.item2 ?? e.Item2 ?? e.item1 ?? e.Item1 ?? e.message ?? e.Message;
                    return msg != null ? String(msg) : null;
                }
                return String(e);
            })
            .filter(Boolean);
    }
    if (data?.errors && typeof data.errors === 'object') {
        return Object.values(data.errors).flat().filter(Boolean);
    }

    return [];
};

// Wrapper para usar hooks en class component
function SellerEditWrapper(props) {
    const navigate = useNavigate();
    const { id } = useParams();
    const location = useLocation();
    return <SellerEdit {...props} navigate={navigate} id={id} location={location} />;
}

class SellerEdit extends React.Component {
    constructor(props) {
        super(props);
        const { isCategory, isAdminMod, isSellerAdmin } = this.props.userType;
        this.isSeller = !isCategory && !isAdminMod && !isSellerAdmin;

        this.state = {
            activeTab: this.props.location.state ?? 0,
            tabs: [
                { name: "Datos Básicos ", icon: "ti-id-badge", content: <DatosBasicos /> },
                { name: "Datos de contactos", icon: "ti-headphone-alt", content: <DatosContactos /> },
                { name: "Publicación ", icon: "mdi mdi-tag", content: <Publicacion history={this.props.history} /> },
                {
                    name: "Moderador", icon: "ti-shield",
                    content: <Moderador
                        tipoUsuario={this.props.tipoUsuario}
                        changeTab={this.onChangeActiveTab}
                        navigate={this.props.navigate}
                        location={this.props.location} />

                },
                { name: "Administrar Cuenta", icon: "mdi mdi-email-outline", content: <MailUsuario /> },
                { name: "Liquidacion", icon: "mdi mdi-chart-bar", content: <Liquidacion tipoUsuario={this.props.tipoUsuario} /> },
                ...(isCategory || isAdminMod) ? [
                    { name: "Banner Tienda", icon: "mdi mdi-store", content: <BannerTienda tipoUsuario={this.props.tipoUsuario} /> }
                ] : [],
                { name: "Datos Bancarios", icon: "mdi mdi-bank", content: <DatosBancarios tipoUsuario={this.props.tipoUsuario} onSendPdf={this.handlePdfFromBankData} idSeller={Number.parseInt(this.props.id)} onChangeBankData={this.handleBankDataChange} /> },
                { name: "Auditoria", icon: "mdi mdi-file-document", readOnly: true, content: <AuditoriaPrecioStock auditoriaScope="seller" /> },
                ...(isSellerAdmin || this.isSeller || isCategory || isAdminMod) ? [
                    {
                        name: "ZIP Nova",
                        icon: "mdi mdi-map-marker",
                        content: <Zipnova
                                    tipoUsuario={this.props.tipoUsuario}
                                    idSeller={Number.parseInt(this.props.id)}
                                    id={this.props.userId}
                                    readOnly={isCategory || isAdminMod}
                                 />
                    }
                ] : [],
            ],
            showSpinner: false,
            originalCdns: [],
            archivoPdf: "",
            hasPdf: false,
            logisticaPropiaEscalas: [],
            datosBancariosForm: null,
            hasCbuManual: false,
            promesaEntregaTemp: null,
        };
    }

    componentDidMount() {
        if (this.props.location.pathname !== `/Sellers/Editar/Select/${this.props.id}`) {
            this.props.setObject({});
        }

        this.props.editUsuario({});
        this.props.editando(true);
        this.props.fetchSeller(this.props.id);

        this.props.fetchUsuarios({ idSeller: Number.parseInt(this.props.id) });

        if (this.props.location.pathname !== `/Sellers/Editar/Select/${this.props.id}`) {
            this.props.fetchTiposPublicacionAdmById({ idSeller: Number.parseInt(this.props.id) });
        }


        if (this.isSeller) {
            let tabsSeller = [
                { name: "Datos Básicos ", icon: "ti-id-badge", content: <DatosBasicos estado={this.props.seller.estado} /> },
                { name: "Datos de contactos", icon: "ti-headphone-alt", content: <DatosContactos /> },
                { name: "Publicación", icon: "mdi mdi-tag", content: <Publicacion history={this.props.history} /> },
                { name: "Administrar Cuenta", icon: "mdi mdi-email-outline", content: <MailUsuario /> },
                { name: "Datos Bancarios", icon: "mdi mdi-bank", content: <DatosBancarios tipoUsuario={this.props.tipoUsuario} onSendPdf={this.handlePdfFromBankData} idSeller={Number.parseInt(this.props.id)} onChangeBankData={this.handleBankDataChange} /> },
                { name: "Auditoria", icon: "mdi mdi-file-document", readOnly: true, content: <AuditoriaPrecioStock auditoriaScope="seller" /> },
                {
                    name: "ZIP Nova",
                    icon: "mdi mdi-map-marker",
                    content: <Zipnova
                                tipoUsuario={this.props.tipoUsuario}
                                idSeller={Number.parseInt(this.props.id)}
                                id={this.props.userId}
                                readOnly={false}
                             />
                }
            ]

            this.setState({ tabs: tabsSeller });
        }
    }

    componentDidUpdate(prevProps) {
        // Si cambia el id del seller, limpiar el objeto general para evitar valores viejos
        if (this.props.id !== prevProps.id) {
            this.props.setObject({});
            this.setState({ promesaEntregaTemp: this.props.seller?.promesaEntrega ?? null });
        }

        if (this.props.seller?.promesaEntrega !== prevProps.seller?.promesaEntrega) {
            this.setState({ promesaEntregaTemp: this.props.seller?.promesaEntrega ?? null });
        }

        if (this.props.seller !== prevProps.seller) {
            const { cdn, envioPropio } = this.props.seller;

            if (envioPropio === true) {
                const isSeller = this.props.userType.isSellerAdmin || this.props.userType.isSeller;
                const tabLogisticaPropia = {
                    name: "Logística Propia",
                    icon: "mdi mdi-truck",
                    content: (
                        <LogisticaPropia
                            idSeller={this.props.id}
                            userType={this.props.userType}
                            readOnly={!isSeller} // Solo los sellers pueden editar
                            zonas={this.state.logisticaPropiaZonas}
                            onChangeZonas={this.handleChangeZonas}
                            logisticaPropia={this.props.seller.logisticaPropia}
                        />
                    )
                };
                const tabExists = this.state.tabs.some(tab => tab.name === "Logística Propia");
                if (!tabExists) {
                    this.setState(prev => ({ tabs: [...prev.tabs, tabLogisticaPropia] }));
                }
            }

            if (this.state.originalCdns.length === 0 && Array.isArray(cdn)) {
                this.setState({
                    originalCdns: structuredClone(cdn)
                });
            }
        }
    }

    onChangeActiveTab = (index) => { this.setState({ activeTab: index }) };

    onSubmit = async (event) => {
        event.preventDefault();

        const { usuarioError, usuario, seller } = this.props;
        const { isCategory, isAdminMod } = this.props.userType;
        const isAdminModOrIsCategory = isAdminMod || isCategory;

        if (isAdminModOrIsCategory) {
            try {
                const cuitDigits = (seller?.cuit == null ? '' : String(seller.cuit).trim()).replace(/\D/g, '');
                if (cuitDigits.length !== 11) {
                    toast.warn("CUIT inválido: deben ser 11 dígitos");
                    return;
                }

                if (this.hayCambiosEnCDNs()) {
                    if (!this.validarCDNsCompletos()) {
                        return;
                    }

                    await this.actualizarCDNSeller(seller.codigo);
                }
                this.updateSeller(); // solo si no hay error arriba
            } catch (err) {
                // se frena todo si falla
                console.error("Fallo en actualizarCDNSeller", err);
                return;
            }
        } else {
            if (JSON.stringify(usuario) !== "{}") {
                setTimeout(() => {
                    if (!usuario.error) {
                        this.props.editUsuario({});
                        this.submitFromSeller();
                    }
                }, 500);
            } else if (usuarioError) {
                toast.error("Las contraseñas no coinciden");
            } else {
                this.submitFromSeller();
            }
        }
    };

    actualizarCDNSeller = async (codigo) => {
        const cdnsActuales = this.props.seller?.cdn ?? [];
        const cdnsOriginales = this.state.originalCdns ?? [];
        const cdnsActualesSinEliminados = cdnsActuales.filter(cdn => !cdn.eliminado);

        const cdnsEliminados = cdnsOriginales.filter(original => {
            const sigueExistiendo = cdnsActualesSinEliminados.some(actual => actual.id === original.id);
            return !sigueExistiendo;
        });

        const cdnsModificados = cdnsActualesSinEliminados
            .filter(cdnActual => cdnActual.idSeller !== null)
            .map(cdnActual => ({
                id: cdnActual.id,
                descripcion: cdnActual.descripcion || "",
                urlDescktop: cdnActual.urlDescktop || "",
                urlMovile: cdnActual.urlMovile || "",
                vigenciaDesde: cdnActual.vigenciaDesde,
                vigenciaHasta: cdnActual.vigenciaHasta,
                linkRedireccion: cdnActual.linkRedireccion,
            }));
        const cdnsNuevos = cdnsActualesSinEliminados.filter(cdnActual => !cdnActual.id);

        if (cdnsModificados.length === 0 && cdnsNuevos.length === 0 && cdnsEliminados.length === 0) {
            return;
        }

        try {
            this.setState({ showSpinner: true });

            const requests = [];

            if (cdnsModificados.length > 0 || cdnsEliminados.length > 0) {
                const payload = {
                    idSeller: codigo,
                    bannersSellers: cdnsModificados
                };
                requests.push(() => updateCdnSellerApi(payload));
            }

            if (cdnsNuevos.length > 0) {
                const nuevosValidos = cdnsNuevos.filter(cdn =>
                    cdn.vigenciaDesde && cdn.vigenciaHasta
                );

                nuevosValidos.forEach(cdn => {
                    const request = {
                        descripcion: cdn.descripcion || "",
                        urlDescktop: cdn.urlDescktop || "",
                        urlRedireccion: cdn.linkRedireccion || "",
                        urlMovile: cdn.urlMovile || "",
                        idSeller: codigo,
                        fechaDesde: cdn.vigenciaDesde,
                        fechaHasta: cdn.vigenciaHasta,
                    };

                    requests.push(() => postCrearCdnSellerApi(request));
                });

                if (nuevosValidos.length < cdnsNuevos.length) {
                    toast.warn("Algunos CDNs nuevos fueron ignorados por no tener fechas válidas");
                }
            }

            if (requests.length > 0) {
                for (const req of requests) {
                    await req();
                }
                toast.success("CDNs actualizados, creados y eliminados con éxito");
            } else {
                this.props.navigate("/Sellers");
            }
        } catch (err) {
            (err.response.data.errores)
                ? err.response.data.errores.forEach(error => toast.error(error))
                : toast.error("Ocurrió un error al actualizar algunos CDNs");
            throw err;
        } finally {
            this.setState({ showSpinner: false });
        }
    };

    validarCDNsCompletos = () => {
        const cdnsActuales = this.props.seller?.cdn ?? [];
        const cdnsOriginales = this.state.originalCdns ?? [];
        const cdnsActualesSinEliminados = cdnsActuales.filter(cdn => !cdn.eliminado);

        const tieneContenido = (valor) => {
            if (valor == null) {
                return false;
            }

            return String(valor).trim() !== "";
        };

        const esCdnCompleto = (cdn) => (
            tieneContenido(cdn.descripcion)
            && tieneContenido(cdn.urlDescktop)
            && tieneContenido(cdn.urlMovile)
            && tieneContenido(cdn.vigenciaDesde)
            && tieneContenido(cdn.vigenciaHasta)
            && tieneContenido(cdn.linkRedireccion)
        );

        const cdnsIncompletos = cdnsActualesSinEliminados.filter(cdnActual => {
            const original = cdnsOriginales.find(cdnOriginal => cdnOriginal.id === cdnActual.id);
            const esNuevo = !cdnActual.id;
            const fueModificado = original && (
                original.descripcion !== cdnActual.descripcion ||
                original.urlDescktop !== cdnActual.urlDescktop ||
                original.urlMovile !== cdnActual.urlMovile ||
                original.vigenciaDesde?.substring(0, 10) !== cdnActual.vigenciaDesde?.substring(0, 10) ||
                original.vigenciaHasta?.substring(0, 10) !== cdnActual.vigenciaHasta?.substring(0, 10) ||
                original.linkRedireccion !== cdnActual.linkRedireccion
            );

            return (esNuevo || fueModificado) && !esCdnCompleto(cdnActual);
        });

        if (cdnsIncompletos.length > 0) {
            toast.warn("Complete todos los campos de los banners antes de guardar");
            return false;
        }

        return true;
    };


    hayCambiosEnCDNs = () => {
        const cdnsActuales = this.props.seller?.cdn ?? [];
        const cdnsOriginales = this.state.originalCdns ?? [];
        const cdnsActualesSinEliminados = cdnsActuales.filter(cdn => !cdn.eliminado);

        const cdnsEliminados = cdnsOriginales.filter(original =>
            !cdnsActualesSinEliminados.some(actual => actual.id === original.id)
        );

        const cdnsModificados = cdnsActualesSinEliminados.filter(cdnActual => {
            const original = cdnsOriginales.find(c => c.id === cdnActual.id);
            return original && (
                original.descripcion !== cdnActual.descripcion ||
                original.urlDescktop !== cdnActual.urlDescktop ||
                original.urlMovile !== cdnActual.urlMovile ||
                original.vigenciaDesde?.substring(0, 10) !== cdnActual.vigenciaDesde?.substring(0, 10) ||
                original.vigenciaHasta?.substring(0, 10) !== cdnActual.vigenciaHasta?.substring(0, 10) ||
                original.linkRedireccion !== cdnActual.linkRedireccion
            );
        });

        const cdnsNuevos = cdnsActualesSinEliminados.filter(cdnActual => !cdnActual.id);

        return cdnsModificados.length > 0 || cdnsNuevos.length > 0 || cdnsEliminados.length > 0;
    };

    updateSeller = () => {
        const { seller, sellers } = this.props;
        const { hasPdf, hasCbuManual, promesaEntregaTemp } = this.state;

        if (hasPdf) {
            this.pdfDatoBancario();
        }

        if (hasCbuManual) {
            this.cargaManualCbuSeller();
        }

        this.asignarTipoPublicacion().catch(() => {
            toast.warn("Tipo de publicación no asociado");
        });
        const updatedSeller = {
            ...seller,
            promesaEntrega: promesaEntregaTemp,
            idUsuario: Number.parseInt(this.props.userId, 10) || 0
        };

        let sellersResponse = putSeller(updatedSeller);
        sellersResponse.then(res => {
            this.props.updateListSellers(sellers, updatedSeller)
                .then(() => {
                    toast.success(res.mensaje);
                    this.goBack(true);
                })
                .catch(err => {
                    const errores = getErroresApi(err);
                    if (errores.length > 0) {
                        errores.forEach(error => toast.error(error));
                    } else {
                        toast.error("No pudo modificarse el seller");
                    }
                });
        }).catch(err => {
            const errores = getErroresApi(err);
            if (errores.length > 0) {
                errores.forEach(error => toast.error(error));
            } else {
                toast.error("No pudo modificarse");
            }
        }).finally(() => {
            this.setState({ showSpinner: false });
        });
    };

    pdfDatoBancario = async () => {
        const { archivoPdf, hasPdf } = this.state;
        const { seller } = this.props;

        if (hasPdf && archivoPdf) {
            try {
                const base64Pdf = await formatFile(archivoPdf);
                const base64SinHeader = base64Pdf.split(',')[1];
                const request = {
                    idSeller: seller.codigo,
                    base64PDF: base64SinHeader
                };

                postCargarDatosBancariosApi(request)
                    .then((response) => toast.success(response.data?.mensaje))
                    .catch((error) => {
                        const errores = getErroresApi(error);
                        if (errores.length > 0) {
                            errores.forEach((errItem) => toast.error(errItem));
                        } else {
                            toast.error("Error al subir el archivo");
                        }
                    });
            } catch {
                toast.error("Archivo inválido");
            }
        } else {
            toast.warning("No hay archivo PDF para subir");
        }
    };

    cargaManualCbuSeller = async () => {
        try {
            const { datosBancariosForm } = this.state;

            let params = {
                idBanco: datosBancariosForm.banco,
                idSeller: datosBancariosForm.idSeller,
                tipoCuenta: Number.parseInt(datosBancariosForm.tipoCuenta),
                numeroCuenta: datosBancariosForm.numeroCuenta,
                cbu: datosBancariosForm.cbu
            }

            postCargarDatosBancariosManualApi(params)
                .then((response) => toast.success(response.data?.mensaje))
                .catch((error) => {
                    const errores = getErroresApi(error);
                    if (errores.length > 0) {
                        errores.forEach((errItem) => toast.error(errItem));
                    } else {
                        toast.error("Error al cargar el formulario");
                    }
                });

        } catch {
            toast.error("No se completó la carga del formulario");
        }
    }

    handlePdfFromBankData = (file) => {
        this.setState({
            archivoPdf: file,
            hasPdf: !!file,
        });
    };

    submitFromSeller = () => {
        let seller = this.props.seller;

        if (!isEmail(seller.email)) {
            toast.warn("e-Mail incorrecto");
            return;
        }

        const cuitDigits = (seller?.cuit == null ? '' : String(seller.cuit).trim()).replace(/\D/g, '');
        if (cuitDigits.length !== 11) {
            toast.warn("CUIT inválido: deben ser 11 dígitos");
            return;
        }

        this.setState({ showSpinner: true });
        this.updateSeller();
    }

    asignarTipoPublicacion = async () => {
        try {
            const { settedTiposPublicacion, seller } = this.props;

            const tiposArr = Array.isArray(settedTiposPublicacion)
                ? settedTiposPublicacion
                : (settedTiposPublicacion && typeof settedTiposPublicacion === 'object' && settedTiposPublicacion.codigo != null)
                    ? [settedTiposPublicacion]
                    : [];

            const idUsuario = Number.parseInt(this.props.userId, 10) || 0;
            const idSellerRaw = seller?.codigo ?? seller?.idSeller ?? seller?.Codigo ?? seller?.IdSeller;
            const idSeller = Number.parseInt(idSellerRaw, 10) || 0;
            const listaIdsTipoPublicacion = tiposArr
                .map((tipo) => resolveTipoPublicacionId(tipo))
                .filter((id) => id != null && Number.isFinite(id) && id > 0);
            const continuarAsignacion = listaIdsTipoPublicacion.length > 0 && idUsuario > 0 && idSeller > 0;

            if (!continuarAsignacion) {
                return;
            }

            const request = {
                idUsuario,
                idSeller,
                listaIdsTipoPublicacion,
            };

            await postTiposPublicacionAsociarSeller(request);
            toast.success("Tipo de publicación asociado");
        } catch {
            toast.warn("Tipo de publicación no asociado");
        }
    }

    onDelete = () => {
        this.setState({ showSpinner: true });
        const { seller, userId } = this.props;

        const req = deleteSellerApi(seller.codigo, Number.parseInt(userId, 10) || 0);
        req.then(res => {
            toast.success("Seller Eliminado");
            this.goBack(true);
        }).catch(err => {
            toast.error("No se pudo eliminar");
        }).finally(() => {
            this.setState({ showSpinner: false });
        });
    }

    goBack = (hasChanges = false) => {
        const { isCategory, isAdminMod } = this.props.userType;
        const navOptions = hasChanges ? { replace: true } : undefined;

        this.props.clearLogisticaForSeller(this.props.id); // limpia reducer

        if (isCategory || isAdminMod) {
            this.props.navigate("/Sellers", navOptions);
        } else {
            this.props.navigate("/", navOptions);
        }
    }

    handleChangeZonas = (zonas) => {
        this.setState({ logisticaPropiaZonas: zonas });
    };

    handleBankDataChange = (data) => {
        this.setState({
            datosBancariosForm: data,
            hasCbuManual: true,
        });
    };

    openStorePreview = (e) => {
        e.preventDefault();
        const { seller } = this.props;
        let slug = seller?.slugTienda || "";
        slug = slug.replaceAll(/['"]+/g, '');

        if (slug) {
            window.open(`https://www.megatone.net/tiendas/${slug}/`, '_blank');
        } else {
            toast.warn("La tienda no tiene una url asignada");
        }
    }

    handlePromesaEntregaChange = (e) => {
        const value = e.target.value;

        this.setState({
            promesaEntregaTemp: value === '' ? null : Number(value)
        });
    };

    render() {
        const { isAdminMod } = this.props.userType || {};
        const { seller } = this.props;
        const activeTabConfig = this.state.tabs[this.state.activeTab] ?? {};
        const activeTabIsReadOnly = Boolean(activeTabConfig?.readOnly);

        let codigo = seller?.codigo ?? "";
        let hideLoader = false;
        if (seller?.codigo) {
            // Si el seller tiene logística propia, esperamos a que la tab ya esté agregada
            // antes de sacar el spinner, para que no aparezca "de última" al renderizar.
            const needsLogisticaTab = seller?.envioPropio === true;
            const hasLogisticaTab = this.state.tabs.some(tab => tab.name === "Logística Propia");
            hideLoader = !needsLogisticaTab || hasLogisticaTab;
        }

        let slug = seller?.slugTienda || "";
        slug = slug.replaceAll(/['"]+/g, '');

        return (
            <div className="container">
                <div className="row align-items-center">

                    {!hideLoader ? <BigSpinner message="Cargando datos del seller..." /> :
                        <div className="card">
                            <div className="card-body">
                                <div className="row align-items-center justify-content-between mb-3 seller-edit-header">
                                    <div className="col-auto">
                                        <GoBackArrow onBack={() => this.goBack()} />
                                    </div>
                                    <div className="col">
                                        <h4 className="card-title mb-1">
                                            {this.props.userName} - {seller?.razonSocial}
                                        </h4>
                                        <h6 className="card-subtitle text-muted">Editar Seller - {codigo}</h6>
                                    </div>
                                    <div className="col-auto">
                                        <button
                                            className="btn btn-secondary waves-effect waves-light"
                                            onClick={this.openStorePreview}
                                            title={`Slug: ${slug || 'N/A'}`}
                                            disabled={!slug}
                                            style={{ backgroundColor: '#78A3BA', borderColor: '#78A3BA' }}
                                        >
                                            <i className="mdi mdi-store mr-2"></i>Pagina de la Tienda
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div className="card-body p-b-0">

                                <ul className="nav nav-tabs customtab seller-edit-tabs">
                                    {
                                        this.state.tabs.map((tab, index) => {
                                            return <button key={`navEditSeller-${tab.name}`} onClick={() => this.onChangeActiveTab(index)} style={{ border: 'none', background: 'none' } }>
                                                <Tab name={tab.name} icon={tab.icon} isActive={index === this.state.activeTab} />
                                            </button>
                                        })
                                    }
                                </ul>

                                <form className="form-horizontal form-material p-10" onSubmit={this.onSubmit}>
                                    <div className="tab-content">

                                        {this.state.tabs[this.state.activeTab].content}

                                        {!activeTabIsReadOnly && <div className="row align-items-center justify-content-center mb-3 text-center seller-edit-actions">

                                            <div className="col-12 col-sm-auto" hidden={!this.state.showSpinner}>
                                                <MiniSpinner />
                                            </div>

                                            <div className="d-flex justify-content-center">
                                                <button
                                                    type="submit"
                                                    className="btn btn-sm background-rojo-megatone waves-light mx-1"
                                                    disabled={this.state.showSpinner}
                                                >
                                                    Guardar
                                                </button>

                                                {isAdminMod &&
                                                    <ModalItem
                                                        btnStyle="btn btn-sm btn-grey mx-1"
                                                        btnText="Eliminar"
                                                        text="¿Desea eliminar Seller?"
                                                        disabled={this.state.showSpinner}
                                                        onDelete={this.onDelete}
                                                        show={this.state.showModal}
                                                    />
                                                }

                                                <button
                                                    type="button"
                                                    onClick={() => this.goBack()}
                                                    className="btn btn-sm btn-light waves-effect waves-light mx-1"
                                                >
                                                    Cancelar
                                                </button>
                                            </div>

                                        </div>}

                                    </div>
                                </form>

                            </div>
                        </div>
                    }

                </div>
            </div>
        );
    }
}
SellerEdit.propTypes = {
    // Propiedades de hooks
    id: PropTypes.string,
    location: PropTypes.shape({
        state: PropTypes.number,
        pathname: PropTypes.string
    }),
    navigate: PropTypes.func,
    // Propiedades redux
    userType: PropTypes.shape({
        isAdminMod: PropTypes.bool,
        isCategory: PropTypes.bool,
        isSellerAdmin: PropTypes.bool,
        isSeller: PropTypes.bool
    }),
    history: PropTypes.string,
    tipoUsuario: PropTypes.number,
    userId: PropTypes.number,
    seller: PropTypes.shape({
        estado: PropTypes.string,
        promesaEntrega: PropTypes.string,
        cdn: PropTypes.array,
        envioPropio: PropTypes.bool,
        logisticaPropia: PropTypes.shape({
            zonasUI: PropTypes.number,
            escalas: PropTypes.array,
        }),
        codigo: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        email: PropTypes.string,
        slugTienda: PropTypes.string,
        razonSocial: PropTypes.string,
    }),
    usuarioError: PropTypes.bool,
    usuario: PropTypes.shape({
        error: PropTypes.bool,
    }),
    sellers: PropTypes.oneOfType([PropTypes.shape({
        paginateSellers: PropTypes.shape({
            elementos: PropTypes.arrayOf(
                PropTypes.shape({
                    codigo: PropTypes.number,
                    cuit: PropTypes.string,
                    razonSocial: PropTypes.string,
                    codigoPostal: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
                    telefono: PropTypes.string,
                    estado: PropTypes.string,
                    domicilio: PropTypes.string,
                    email: PropTypes.string,
                    emailDespacho: PropTypes.string,
                    numeroDomicilio: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
                    localidad: PropTypes.string,
                    provincia: PropTypes.string,
                })
            ),
            cantidadPagina: PropTypes.number,
        }),
    }), PropTypes.array]),
    settedTiposPublicacion: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.array]),
    userName: PropTypes.string,
    // Propiedades actions
    editando: PropTypes.func,
    editUsuario: PropTypes.func,
    setObject: PropTypes.func,
    fetchSeller: PropTypes.func,
    fetchUsuarios: PropTypes.func,
    fetchTiposPublicacionAdmById: PropTypes.func,
    updateListSellers: PropTypes.func,
    clearLogisticaForSeller: PropTypes.func,
}

const mapStateToProps = state => ({
    usuario: state.usuarios.user,
    userName: state.general.userName,
    userType: state.general.userType,
    tipoUsuario: state.general.tipoUsuario,
    facturaciones: state.facturaciones,
    usuarioError: state.usuarios.error,
    settedTiposPublicacion: state.tiposPublicacion.setTiposPublicacion,
    //settedTiposPublicacion: state.publicaciones.tiposPublicacion,
    seller: selectSellerMerged(state),
    sellers: state.sellers.sellers,
    userId: state.general.userId,
});

export default withNavigation(connect(mapStateToProps, {
    fetchSeller,
    editUsuario,
    editando,
    setObject,
    fetchTiposPublicacionAdmById,
    resetSellers,
    updateListSellers,
    fetchUsuarios,
    clearLogisticaForSeller
})(SellerEditWrapper));
